import React from "react";
import { ChantInput } from "../../../../../../CommonComponents";
import "../styles/eventFormStyles.css";
import useContentFormParams from "../hooks/useContentFormParams";

export const AnnouncementLinksSection = ({
  articleLink,
  podcastLink,
  videoLink,
  onArticleLinkChange,
  onPodcastLinkChange,
  onVideoLinkChange,
}) => {
  const { formMode } = useContentFormParams();
  return (
    <>
      <div className="event-form-field-wrapper">
        <ChantInput
          label="Read (Article Link)"
          value={articleLink}
          onChange={onArticleLinkChange}
          placeholder="Link to article or add details below"
          disabled={formMode === "view"}
        />
        <div className="event-form-help-text">
          If blank, the Read button will open the card showing news from
          &apos;Details&apos; below.
        </div>
      </div>

      <div className="event-form-field-wrapper">
        <ChantInput
          label="Listen (Podcast Link)"
          value={podcastLink}
          onChange={onPodcastLinkChange}
          placeholder="Link to podcast"
          disabled={formMode === "view"}
        />
      </div>

      <div className="event-form-field-wrapper">
        <ChantInput
          label="Watch (Video Link)"
          value={videoLink}
          onChange={onVideoLinkChange}
          placeholder="Link to video"
          disabled={formMode === "view"}
        />
      </div>
    </>
  );
};
